import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyMotivationsComponent } from './my-motivations/my-motivations.component';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { UserProfileComponent } from './user-profile/user-profile/user-profile.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { FirstTimeLoginComponent } from './first-time-login/first-time-login/first-time-login.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MakeMoovModule } from '../make-moov/make-moov.module';
import { VerifyPhoneNumberComponent } from './verify-phone-number/verify-phone-number.component';
import { PulsecheckViewComponent } from './pulsecheck-view/pulsecheck-view.component';
import { SubmissionSuccessComponent } from './pulsecheck-view/submission-success/submission-success.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    MyMotivationsComponent,
    UserProfileComponent,
    FirstTimeLoginComponent,
    VerifyPhoneNumberComponent,
    PulsecheckViewComponent,
    SubmissionSuccessComponent
  ],
  imports: 
  [
    CommonModule,
    MatButtonModule,
    MoovCommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    FormsModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MakeMoovModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ],
  exports: [
    MyMotivationsComponent
  ]
})
export class PersonalViewModule { }
